
<div class="w-full flex flex-row justify-center contact-us-outer-container">
  <div class="flex flex-col lg:flex-row justify-center lg:justify-between items-center w-full mx-5 font-rubik max-w-1216">
    <div class="flex flex-col gap-6 mb-12 lg:mb-0">
      <div>
        <h2 class="service-area-contact-us-h2">Have questions or</h2>
        <h2 class="service-area-contact-us-h2">need assistance?</h2>
      </div>
      <div>
        <p class="service-area-contact-us-p">
          Our customer support team is ready to assist you with any questions or concerns.
          Contact us via phone, and we'll ensure you find the perfect container solution.
        </p>
      </div>
      <div class="flex gap-8 lg:gap-4 items-center">
        <!-- <a :href="'mailto:' + email" 
          class="service-area-email-button border rounded-full py-2 px-1 font-semibold flex items-center justify-center"
          :style="page == 'partners' ? { background: organization.data.brand_color } : {background: '#4D84FF'}"
        >
          Email Us
        </a> -->
        <a 
          v-if="phone"
          :href="`tel:${phone}`" 
          class="service-area-phone-a"
        >
          {{ formatPhoneNumber(phone) }}
        </a>
      </div>
    </div>

    <img class="service-area-img" :src="organizationLogo" :alt="organization.name">
  </div>
</div>
